import { ServiceRequestStatus } from "@/constants/entity-status";
import { PermissionCode } from "@/constants/permissions";
import { SolicitudVoleoDetail } from "@/services/voleo-requests.service";
import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Check, X } from "lucide-react";

interface Props {
  detail: SolicitudVoleoDetail | null;
  hasWriteAccess: (permission: PermissionCode) => boolean | undefined;
  loadingReject: boolean;
  loadingDone: boolean;
  loadingClose: boolean;
  setOpenDoneModal: (value: boolean) => void;
  setOpenRejectModal: (value: boolean) => void;
  handleCloseRequest: () => void;
}

export const VoleoRequestActionButtons = ({
  detail,
  hasWriteAccess,
  loadingReject,
  loadingDone,
  loadingClose,
  setOpenDoneModal,
  setOpenRejectModal,
  handleCloseRequest,
}: Props) => {
  return (
    <>
      {detail &&
        detail?.estado === ServiceRequestStatus.PENDING &&
        hasWriteAccess(PermissionCode.BROADCAST_REQUEST) && (
          <Flex justifyContent="flex-end" gap="12px">
            <Button
              paddingX="12px"
              height="32px"
              bgColor={AppColors.LIGHT_GREEN}
              disabled={loadingReject || loadingDone || loadingClose}
              onClick={() => setOpenDoneModal(true)}
            >
              <Check />
              <Text fontWeight={600} fontSize="14px">
                Marcar realizado
              </Text>
            </Button>

            <Button
              paddingX="12px"
              height="32px"
              bgColor={AppColors.RED_BUTTON_ALT}
              disabled={loadingReject || loadingDone || loadingClose}
              onClick={() => setOpenRejectModal(true)}
            >
              <X />
              <Text fontWeight={600} fontSize="14px" color={AppColors.WHITE_SECONDARY}>
                Rechazar
              </Text>
            </Button>
          </Flex>
        )}

      {detail?.estado === ServiceRequestStatus.DONE &&
        hasWriteAccess(PermissionCode.BROADCAST_REQUEST) && (
          <Flex justifyContent="flex-end" gap="12px">
            <Button
              paddingX="12px"
              height="32px"
              bgColor={AppColors.BLACK_TEXT_SECONDARY}
              disabled={loadingReject || loadingDone || loadingClose}
              onClick={handleCloseRequest}
            >
              <Check />
              <Text fontWeight={600} fontSize="14px">
                Cerrar
              </Text>
            </Button>
          </Flex>
        )}
    </>
  );
};
